import { Section, TenantSettings } from "../components"

export const TenantSettingsPage = () => {
  return <div className="page">
    <Section>
      <TenantSettings />
    </Section>
  </div>
}

export default TenantSettingsPage